import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63e468a0")

_pushScopeId("data-v-63e468a0")
const _hoisted_1 = { class: "dhm_container" }
const _hoisted_2 = { class: "dhm_fail" }
const _hoisted_3 = { class: "fail_head flex_space_center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "提示", -1)
const _hoisted_5 = { class: "fail_text" }
const _hoisted_6 = { class: "fail_action flex_end_center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("i", {
          class: "fail_close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeFailModel && _ctx.closeFailModel(...args)))
        })
      ]),
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.error_text), 1),
      _createVNode("div", _hoisted_6, [
        _createVNode("span", {
          class: "confirm_btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeFailModel && _ctx.closeFailModel(...args)))
        }, "确定")
      ])
    ])
  ]))
})